import request from '../utils/request';

/**
 * 月度数据驾驶舱大屏 —— 接口
 * 后端：/sys/battlescreen/*
 */

/**
 * 加载大屏全量数据（四个轮播区块 + KPI 汇总）
 * @param {Object} param { flags:[], areaIds:[], paymentIds:[], month:'yyyy-MM' }
 */
export const loadScreenData = (param) => {
    return request({
        url: '/sys/battlescreen/loadScreenData',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(param || {}),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 可勾选的收款账户列表
 */
export const getPaymentOptions = () => {
    return request({
        url: '/sys/battlescreen/paymentOptions',
        method: 'GET'
    });
};

/**
 * 可勾选的区域/校区多级树
 * @param {Array<number>} flags 业务线：1中招 2少年 4高考 5幼儿
 */
export const getBattleAreaTree = (flags) => {
    return request({
        url: '/sys/battlescreen/areaTree',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(flags || []),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 大屏在线屏数
 */
export const getOnlineCount = () => {
    return request({
        url: '/sys/battlescreen/onlineCount',
        method: 'GET'
    });
};
